export const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

// Limits string to maxLength and appends an ellipses if longer.
export const ellipsesText = (str, maxLength=50) => {
    return str.substring(0, Math.min(maxLength, str.length)) + (str.length > maxLength ? '...' : '');
}